import { AuthProvider } from "./AuthContext/AuthContext";
import { FirstLoadProvider } from "./ModalTools/ModalTools";
import { NotificationsProvider } from "./Notifications/NotificationsContext";

import { combineComponents } from "../utils/combineComponents";

const providers = [AuthProvider, FirstLoadProvider, NotificationsProvider];

export const AppContextProvider = combineComponents(...providers);
